(function () {
  'use strict';

  var COLOR_GROUPS = {
    white: {
      label: 'White',
      color: '#E2E2E2',
      materials: ['925 Sterling Silver', '14K White Gold', '18K White Gold']
    },
    yellow: {
      label: 'Yellow',
      color: '#D4AF5A',
      materials: ['18K Yellow Gold Vermeil', '14K Yellow Gold', '18K Yellow Gold']
    },
    rose: {
      label: 'Rose',
      color: '#C9897A',
      materials: ['18K Rose Gold Vermeil', '14K Rose Gold', '18K Rose Gold']
    }
  };

  var SWATCH_SIZE = '14px';

  function getMaterialGroup(material) {
    for (var key in COLOR_GROUPS) {
      if (COLOR_GROUPS[key].materials.indexOf(material) !== -1) return key;
    }
    return null;
  }

  function getSelectsForMaterial() {
    return Array.from(document.querySelectorAll('select[name^="options[Material"]'));
  }

  function getAvailableGroups(select) {
    var groups = [];
    Array.from(select.options).forEach(function (opt) {
      var group = getMaterialGroup(opt.value);
      if (group && groups.indexOf(group) === -1) groups.push(group);
    });
    return groups;
  }

  function filterSelect(select, groupKey) {
    var allowed = COLOR_GROUPS[groupKey].materials;
    var firstMatch = null;
    Array.from(select.options).forEach(function (opt) {
      var inGroup = allowed.indexOf(opt.value) !== -1;
      opt.hidden = !inGroup;
      opt.disabled = !inGroup;
      if (inGroup && !firstMatch) firstMatch = opt.value;
    });
    if (firstMatch) {
      select.value = firstMatch;
    }
  }

  // Directly invoke VariantSelects update pipeline so image swap fires
  // (the normal 'change' event hits the wrong branch in onVariantChange for selects inside divs)
  function triggerVariantUpdate() {
    var variantSelectEls = document.querySelectorAll('variant-selects');
    variantSelectEls.forEach(function (el) {
      if (typeof el.updateOptions !== 'function') return;
      el.updateOptions();
      el.updateMasterId();
      el.toggleAddButton(true, '', false);
      el.updatePickupAvailability();
      el.removeErrorMessage();
      el.updateVariantText();
      el.setDisabled();
      if (!el.currentVariant) {
        el.toggleAddButton(true, '', true);
        el.setUnavailable();
      } else {
        el.updateMedia();
        if (!el.featured) { el.updateURL(); }
        el.updateVariantInput();
        el.renderProductInfo();
        el.updateOther();
      }
    });
  }

  function setSelected(wrapper, groupKey, labelEl) {
    wrapper.querySelectorAll('[data-swatch-wrap]').forEach(function (wrap) {
      var isActive = wrap.getAttribute('data-color-group') === groupKey;
      var underline = wrap.querySelector('[data-swatch-underline]');
      var btn = wrap.querySelector('button');
      if (underline) underline.style.display = isActive ? 'block' : 'none';
      if (btn) btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    if (labelEl) labelEl.textContent = COLOR_GROUPS[groupKey].label + ' Metal';
  }

  function buildSwatches(selects, availableGroups) {
    var defaultGroup = availableGroups.indexOf('white') !== -1 ? 'white' : availableGroups[0];

    var container = document.createElement('div');
    container.setAttribute('data-color-swatches', '');
    container.className = 'product-form__input';
    container.style.cssText = 'margin-bottom:12px;';

    var header = document.createElement('div');
    header.className = 'form__label';
    header.innerHTML = 'Material Color: <span class="form__label__value" id="color-swatch-label">' + COLOR_GROUPS[defaultGroup].label + ' Metal</span>';
    container.appendChild(header);

    var wrapper = document.createElement('div');
    wrapper.className = 'color-swatch-group';
    wrapper.style.cssText = 'display:flex;gap:8px;align-items:flex-start;margin-top:8px;';
    container.appendChild(wrapper);

    var labelEl = header.querySelector('#color-swatch-label');

    availableGroups.forEach(function (groupKey) {
      var group = COLOR_GROUPS[groupKey];

      var wrap = document.createElement('div');
      wrap.setAttribute('data-swatch-wrap', '');
      wrap.setAttribute('data-color-group', groupKey);
      wrap.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:3px;cursor:pointer;flex-shrink:0;';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.title = group.label;
      btn.setAttribute('aria-label', group.label + ' metals');
      btn.setAttribute('aria-pressed', groupKey === defaultGroup ? 'true' : 'false');
      btn.setAttribute('style', [
        'width:' + SWATCH_SIZE,
        'height:' + SWATCH_SIZE,
        'min-width:' + SWATCH_SIZE,
        'min-height:' + SWATCH_SIZE,
        'max-width:' + SWATCH_SIZE,
        'max-height:' + SWATCH_SIZE,
        'border-radius:2px',
        'background:' + group.color,
        'border:none',
        'box-shadow:none',
        'cursor:pointer',
        'padding:0',
        'margin:0',
        'outline:none',
        'display:block',
        'flex-shrink:0',
        'box-sizing:content-box',
        'appearance:none',
        '-webkit-appearance:none'
      ].join(';'));

      var underline = document.createElement('span');
      underline.setAttribute('data-swatch-underline', '');
      underline.setAttribute('style', 'display:' + (groupKey === defaultGroup ? 'block' : 'none') + ';width:' + SWATCH_SIZE + ';height:2px;background:#000;border-radius:1px;flex-shrink:0;');

      wrap.appendChild(btn);
      wrap.appendChild(underline);

      wrap.addEventListener('click', function () {
        setSelected(wrapper, groupKey, labelEl);
        selects.forEach(function (select) {
          filterSelect(select, groupKey);
        });
        triggerVariantUpdate();
      });

      wrapper.appendChild(wrap);
    });

    return { container: container, defaultGroup: defaultGroup };
  }

  function initColorSwatches() {
    if (document.querySelector('[data-color-swatches]')) return;

    var selects = getSelectsForMaterial();
    if (!selects.length) return;

    var primarySelect = selects[0];
    var availableGroups = getAvailableGroups(primarySelect);

    if (availableGroups.length < 2) return;

    var result = buildSwatches(selects, availableGroups);
    var container = result.container;
    var defaultGroup = result.defaultGroup;

    var fieldset = primarySelect.closest('fieldset');
    if (!fieldset) return;
    fieldset.parentNode.insertBefore(container, fieldset);

    selects.forEach(function (select) {
      filterSelect(select, defaultGroup);
    });
    triggerVariantUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorSwatches);
  } else {
    initColorSwatches();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initColorSwatches, 50);
  });

})();
